import TableLoading from "../../../Components/Loader/TableLoading";
import SVG from "../../../Components/SVG";
import FriendsGridCard from "./FriendsGridCard";

export default function FriendsGrid({
  rows,
  accLoading,
  isLoadingMore,
}) {
  if (accLoading) {
    return (
      <div className="flex w-full items-center justify-center gap-2">
        <p className="text-[#808080]">در حال بارگذاری</p>
        <TableLoading className="text-[#808080]" />
      </div>
    );
  }

  return (
    <div className="w-full flex flex-col gap-4 max-h-72 overflow-y-auto">
      {rows.map(({ id, ...friend }) => (
        <FriendsGridCard key={id} {...friend} />
      ))}
      {isLoadingMore && rows.length > 0 && (
        <div className="w-full flex justify-center items-center gap-2">
          <p className="text-[#808080]">در حال بارگذاری بیشتر</p>
          <TableLoading className="text-[#808080]" />
        </div>
      )}
      {rows.length === 0 && (
        <div className="w-full flex justify-center items-center flex-col gap-5">
          <p className="text-zi-text-light dark:text-zi-text-dark text-sm sm:text-base">
            موردی برای نمایش وجود ندارد
          </p>
          <SVG name="noData" classname="w-24 fill-cyan-500" />
        </div>
      )}
    </div>
  );
}
